define("shared/helpers/uuid", ["exports", "@ember/component/helper", "shared/utils/uuid"], function (_exports, _helper, _uuid) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"shared/utils/uuid"eaimeta@70e063a35619d71f
  function generateUUID() {
    return (0, _uuid.default)();
  }
  var _default = _exports.default = (0, _helper.helper)(generateUUID);
});